var _circle, _circle2, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#F0F0F0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 21C30 20.5 29.9327 19.2218 28.6852 19.2218H25.3586C24.8596 19.2218 24.4438 18.806 24.5269 18.2238L24.9428 15.5625C25.1091 14.814 24.6101 13.9823 23.8616 13.7328C23.1963 13.4833 22.3646 13.816 22.0319 14.315L18.6221 19.3881",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6221 26.7067L21.2003 28.7027C21.5329 29.0354 22.2814 29.2017 22.7804 29.2017H25.9407C26.9387 29.2017 28.0199 28.4532 28.2694 27.4552L29 25.5",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3809 26.7065V18.5562C14.3809 17.3919 14.8799 16.9761 16.0442 16.9761H16.8759C18.0402 16.9761 18.5392 17.3919 18.5392 18.5562V26.7065C18.5392 27.8709 18.0402 28.2867 16.8759 28.2867H16.0442C14.8799 28.2867 14.3809 27.8709 14.3809 26.7065Z",
    stroke: "#565656",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRate);
export default __webpack_public_path__ + "static/media/icon-rate.879ebdcef5fa12f523807be62142b876.svg";
export { ForwardRef as ReactComponent };